const successDE = {
    addReminder: 'Bestellwecker wurde hinzugefügt',
    editReminder: 'Bestellwecker gespeichert',
    deleteReminder: 'Bestellwecker wurde gelöscht',
    addCart: 'Produkt wurde zum Warenkorb hinzugefügt. | Produkte wurden zum Warenkorb hinzugefügt',
    addPromoPackage: 'Aktionspaket wurde zum Warenkorb hinzugefügt.',
    addCartNumber: '{target} Einzelartikel aus {target2} Artikelpositionen wurden zum Warenkorb hinzugefügt',
    addList: "Produkt wurde zur Liste hinzugefügt. | Produkte wurden zur Liste hinzugefügt.",
    order: "Liste wurde bestellt.",
    save: "{target} wurde erfolgreich gespeichert. | {target} wurden erfolgreich gespeichert.",
    resendMail: 'Email wurde erneut versendet.',
    copyLink: 'Link wurde kopiert',
    sendLink: 'Link wurde versendet.',
    removeProduct: 'Produkt wurde vom Warenkorb entfernt. | Produkte wurden vom Warenkorb entfernt.',
    orderFinish: 'Bestellung wurde erstellt.',
    delete: '{target} wurde aus der Liste entfernt.',
    deleteUser: 'Benutzer wurde gelöscht',
    deleteMulti: '{amount} {target} wurden gelöscht.',
    send: '{target} wurde versendet.',
    create: '{target} wurde erstellt.',
    edit: '{target} wurde erfolgreich bearbeitet.',
    add: '{target} wurde hinzugefügt.',
    deleteTeam: 'Benutzer wurde vom Team entfernt.',
    setRole: 'Benutzerrolle wurde erfolgreich gesetzt',
    joinLocation: 'Location wurde erfolgreich hinzugefügt',
    sendInvite: 'Einladungsmail wurde versendet.',
    sendTicket: 'Ihr Feedback ist bei uns angekommen. Vielen Dank.',
    aiCall: 'Der Octobot ruft dich in Kürze an.'
}

export default successDE
